import React, { FunctionComponent } from 'react'

import { Grid, Icon } from '@material-ui/core'
import { colors } from 'shared/styles/colors'

import { ILabelValueProps } from './LabelValues.types'
import { LabelCard, Title, Value } from './styles'

const LabelValue: FunctionComponent<ILabelValueProps> = ({
  title,
  value,
  icon: IconValue,
  iconFile,
}) => {
  const iconType = () => {
    if (IconValue) {
      return (
        IconValue && (
          <IconValue style={{ width: 16, height: 16, color: colors.blue }} />
        )
      )
    }
    if (iconFile) {
      return (
        <Icon style={{ color: colors.blue }}>
          <img
            src={iconFile}
            alt="icone"
            style={{
              width: 16,
              height: 16,
              display: 'flex',
              alignItems: 'center',
              color: colors.blue,
            }}
          />
        </Icon>
      )
    }
    return <></>
  }

  return (
    <LabelCard>
      <Grid container>
        <Title>{title}</Title>

        <Grid container>
          <Grid item style={{ paddingRight: 5 }}>
            {iconType()}
          </Grid>

          <Grid>
            <Value>{value}</Value>
          </Grid>
        </Grid>
      </Grid>
    </LabelCard>
  )
}

export default LabelValue
